module.exports = __webpack_public_path__ + "static/media/10-iveco.384b5fc3.jpg";